module.exports = __webpack_public_path__ + "img/b3c66d0fad7a94411fcdabeabd0d2fb8.png";